/* ═══════════════════════════════════════════════════════
   AURIS — main.js
   Vanilla JS IIFE · No dependencies
═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── i18n ── */
  var LANG = localStorage.getItem('pd_lang') || 'es';

  var T = {
    es: {
      ann: [
        '🚚 ENVÍO GRATIS A TODA ESPAÑA · ENTREGA 3–5 DÍAS',
        '🎟️ CÓDIGO AQUASOUND10 — 10% DESCUENTO EN TU PEDIDO',
        '💧 TU MÚSICA EN LA DUCHA · SIN MOJAR EL MÓVIL',
        '🔄 DEVOLUCIONES GRATUITAS EN 30 DÍAS · SIN PREGUNTAS'
      ],
      nav_watches: 'COLINECK', nav_automatic: 'Características', nav_chronograph: 'Reseñas',
      nav_diving: 'FAQ', nav_classic: 'Nosotros', nav_all_watches: 'Comprar ahora →',
      nav_catalog: 'Características', nav_accessories: 'Reseñas', nav_about: 'Nosotros',
      nav_who_we_are: 'Quiénes somos', nav_why_us: 'Por qué elegirnos', nav_contact: 'Contacto →',
      cart_title: 'Carrito', cart_free_shipping: 'Eres elegible para <strong>envío gratuito</strong>.',
      cart_checkout: 'PAGAR DE FORMA SEGURA', cart_empty: 'Tu carrito está vacío.',
      cart_remove: 'Eliminar', cart_added: '✓ ¡Añadido!'
    },
    en: {
      ann: [
        '🚚 FREE SHIPPING TO SPAIN · DELIVERY 3–5 DAYS',
        '🎟️ CODE AQUASOUND10 — 10% OFF YOUR ORDER',
        '💧 YOUR MUSIC IN THE SHOWER · PHONE STAYS DRY',
        '🔄 FREE 30-DAY RETURNS · NO QUESTIONS ASKED'
      ],
      nav_watches: 'COLINECK', nav_automatic: 'Features', nav_chronograph: 'Reviews',
      nav_diving: 'FAQ', nav_classic: 'About', nav_all_watches: 'Shop now →',
      nav_catalog: 'Features', nav_accessories: 'Reviews', nav_about: 'About us',
      nav_who_we_are: 'Who we are', nav_why_us: 'Why choose us', nav_contact: 'Contact →',
      cart_title: 'Cart', cart_free_shipping: 'You are eligible for <strong>free shipping</strong>.',
      cart_checkout: 'SECURE CHECKOUT', cart_empty: 'Your cart is empty.',
      cart_remove: 'Remove', cart_added: '✓ Added!'
    }
  };

  function tr(key) {
    var d = T[LANG] || T.es;
    return d[key] !== undefined ? d[key] : (T.es[key] || key);
  }

  var annCurrent = 0;
  function showAnn(idx) {
    var msgs = (T[LANG] || T.es).ann;
    annCurrent = (idx + msgs.length) % msgs.length;
    var el = document.getElementById('annText');
    if (el) el.textContent = msgs[annCurrent];
  }

  window.applyLanguage = function(lang) {
    LANG = lang;
    localStorage.setItem('pd_lang', lang);
    document.documentElement.lang = lang === 'en' ? 'en' : 'es';
    var d = T[lang] || T.es;
    document.querySelectorAll('[data-i18n]').forEach(function(el) {
      var v = d[el.getAttribute('data-i18n')];
      if (v !== undefined) el.textContent = v;
    });
    document.querySelectorAll('[data-i18n-html]').forEach(function(el) {
      var v = d[el.getAttribute('data-i18n-html')];
      if (v !== undefined) el.innerHTML = v;
    });
    showAnn(0);
  };

  /* ── ANNOUNCEMENT BAR ── */
  function initAnnouncement() {
    var annText = document.getElementById('annText');
    var annPrev = document.getElementById('annPrev');
    var annNext = document.getElementById('annNext');
    if (!annText) return;

    showAnn(0);
    if (annPrev) annPrev.addEventListener('click', function() { showAnn(annCurrent - 1); });
    if (annNext) annNext.addEventListener('click', function() { showAnn(annCurrent + 1); });
    setInterval(function() { showAnn(annCurrent + 1); }, 4000);
  }

  /* ── NAV ── */
  function initNav() {
    const nav = document.getElementById('mainNav');
    if (!nav) return;
    const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const hamburger = document.getElementById('hamburger');
    const navMobile = document.getElementById('navMobile');
    const navClose  = document.getElementById('navClose');

    if (hamburger && navMobile) {
      hamburger.addEventListener('click', () => {
        navMobile.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        hamburger.setAttribute('aria-expanded', 'true');
      });
    }
    if (navClose && navMobile) {
      navClose.addEventListener('click', () => {
        navMobile.classList.remove('is-open');
        document.body.style.overflow = '';
        if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
      });
    }
    if (navMobile) {
      navMobile.querySelectorAll('a').forEach(a => {
        a.addEventListener('click', () => {
          navMobile.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      });
    }
  }

  /* ── REVEAL ON SCROLL ── */
  function initReveal() {
    const els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(el => io.observe(el));
  }

  /* ── NEWSLETTER ── */
  function initNewsletter() {
    const form = document.querySelector('.newsletter-form');
    if (!form) return;
    form.addEventListener('submit', e => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      const orig = btn ? btn.textContent : '';
      if (btn) { btn.textContent = '✓ ¡Suscrito!'; btn.disabled = true; }
      setTimeout(() => {
        if (btn) { btn.textContent = orig; btn.disabled = false; }
      }, 3000);
    });
  }

  /* ── COOKIE BANNER ── */
  window.cookieConsent = function(accepted) {
    localStorage.setItem('pd_cookie_consent', accepted ? 'accepted' : 'rejected');
    if (typeof window.pdSetShopifyConsent === 'function') window.pdSetShopifyConsent(accepted);
    const banner = document.getElementById('cookieBanner');
    if (banner) {
      banner.style.transition = 'opacity .3s';
      banner.style.opacity = '0';
      setTimeout(() => banner.style.display = 'none', 300);
    }
  };

  function initCookies() {
    const banner = document.getElementById('cookieBanner');
    if (!banner) return;
    if (!localStorage.getItem('pd_cookie_consent')) {
      banner.style.display = 'block';
    }
  }

  /* ── FAQ ACCORDION ── */
  function initFAQ() {
    document.querySelectorAll('.faq-q').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var answer = this.nextElementSibling;
        if (answer) answer.classList.toggle('is-open', !expanded);
      });
    });
  }

  /* ── NEWSLETTER (nl-form) ── */
  function initNLForm() {
    var form = document.getElementById('nlForm');
    var success = document.getElementById('nlSuccess');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      form.style.display = 'none';
      if (success) success.classList.add('is-visible');
    });
  }

  /* ── POLICY TITLES ── */
  function initPolicyTitles() {
    if (!window.location.pathname.startsWith('/policies/')) return;
    const map = {
      'refund-policy':    'Política de Devoluciones',
      'shipping-policy':  'Política de Envío',
      'privacy-policy':   'Política de Privacidad',
      'terms-of-service': 'Términos del Servicio',
      'terms-of-sale':    'Términos de Venta',
      'legal-notice':     'Aviso Legal'
    };
    const handle = window.location.pathname.split('/policies/')[1] || '';
    const title = map[handle];
    if (!title) return;
    document.addEventListener('DOMContentLoaded', () => {
      const h1 = document.querySelector('h1');
      if (h1) h1.textContent = title;
      document.title = title + ' — AURIS';
    });
  }

  /* ── CART DRAWER ── */
  function initCartDrawer() {
    var drawer = document.getElementById('cartDrawer');
    var wrapper = document.getElementById('cartDrawerWrapper');
    var overlay = document.getElementById('cartOverlay');
    var closeBtn = document.getElementById('cartClose');
    var navCartBtn = document.getElementById('navCartBtn');
    if (!drawer) return;

    function openDrawer() {
      loadCart();
      if (wrapper) wrapper.classList.add('is-open');
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    window.pdOpenCart = openDrawer;
    function closeDrawer() {
      drawer.classList.remove('is-open');
      if (wrapper) wrapper.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Cart icon opens drawer
    if (navCartBtn) {
      navCartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    }

    function fmt(cents) {
      if (typeof window.pdFormatPrice === 'function') return window.pdFormatPrice(cents);
      return '€' + (cents / 100).toLocaleString('es-ES', {minimumFractionDigits:2, maximumFractionDigits:2});
    }

    function updateNavCount(count) {
      var badge = document.getElementById('navCartCount');
      if (!badge) return;
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }

    function loadCart() {
      fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
        renderCart(cart);
        updateNavCount(cart.item_count);
      }).catch(function(){});
    }

    function renderCart(cart) {
      var itemsEl = document.getElementById('cartItems');
      var countEl = document.getElementById('drawerCount');
      var totalEl = document.getElementById('cartTotal');
      var origEl  = document.getElementById('cartOrigTotal');
      var savEl   = document.getElementById('cartSavings');

      if (countEl) countEl.textContent = cart.item_count;
      if (totalEl) totalEl.textContent = fmt(cart.total_price);

      var originalTotal = cart.items.reduce(function(acc, item) {
        return acc + (item.original_price * item.quantity);
      }, 0);
      var savings = originalTotal - cart.total_price;
      if (origEl) origEl.innerHTML = savings > 0 ? '<span>' + fmt(originalTotal) + '</span>' : '';
      if (savEl)  savEl.textContent = savings > 0 ? '-' + fmt(savings) : '';

      if (!itemsEl) return;
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-empty-msg">' + tr('cart_empty') + '</div>';
        return;
      }
      itemsEl.innerHTML = cart.items.map(function(item) {
        var imgSrc = item.image ? item.image.replace(/(\.\w+)$/, '_160x160$1') : '';
        var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        return '<div class="cart-item" data-key="' + item.key + '">'
          + (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.product_title + '" class="cart-item-img">' : '<div class="cart-item-img"></div>')
          + '<div class="cart-item-info">'
          + '<div class="cart-item-name">' + item.product_title + '</div>'
          + (variantTitle ? '<div class="cart-item-variant">' + variantTitle + '</div>' : '')
          + '<div class="cart-item-price">' + fmt(item.final_line_price) + '</div>'
          + '</div>'
          + '<div class="cart-item-actions">'
          + '<div class="cart-item-qty">'
          + '<button class="qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>'
          + '<span>' + item.quantity + '</span>'
          + '<button class="qty-btn" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>'
          + '</div>'
          + '<button class="cart-item-remove" data-key="' + item.key + '">' + tr('cart_remove') + '</button>'
          + '</div>'
          + '</div>';
      }).join('');

      itemsEl.querySelectorAll('.qty-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          updateItem(btn.dataset.key, parseInt(btn.dataset.qty, 10));
        });
      });
      itemsEl.querySelectorAll('.cart-item-remove').forEach(function(btn) {
        btn.addEventListener('click', function() { updateItem(btn.dataset.key, 0); });
      });
    }

    function updateItem(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: key, quantity: qty})
      }).then(function(r){return r.json();}).then(function(cart){
        renderCart(cart);
        updateNavCount(cart.item_count);
      });
    }

    // Intercept all add-to-cart form submits
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form.getAttribute('action') !== '/cart/add') return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var origText = btn ? btn.innerHTML : '';
      if (btn) { btn.innerHTML = tr('cart_added'); btn.style.background = '#1a5252'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function(r){ return r.json(); })
        .then(function() {
          setTimeout(function() {
            if (btn) { btn.innerHTML = origText; btn.style.background = ''; }
          }, 1500);
          openDrawer();
        })
        .catch(function() { form.submit(); });
    });

    // Load count on page load
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      updateNavCount(cart.item_count);
    });
  }

  /* ── CATALOG QUICK ADD ── */
  window.pdInitQuickAdd = function() {
    document.querySelectorAll('.pd-card-quick').forEach(function(btn) {
      if (btn._pdQAInited) return;
      btn._pdQAInited = true;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var vid = btn.dataset.variant;
        if (!vid) return;
        var orig = btn.textContent;
        btn.textContent = tr('cart_added');
        btn.style.background = '#1a5252';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
        }).then(function() {
          setTimeout(function() {
            btn.textContent = orig;
            btn.style.background = '';
            // Abrir drawer con loadCart() incluido
            if (window.pdOpenCart) {
              window.pdOpenCart();
            }
          }, 800);
        }).catch(function() {
          btn.textContent = orig;
          btn.style.background = '';
        });
      });
    });
  };

  /* ── COLLECTION TILES / FILTER NAV ── */
  function initCollectionNav() {
    var FILTER_KEYS = ['colineck','ventilador','wearable'];

    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var match = href.match(/^\/?#(.+)/);
      if (!match) return;
      var hash = match[1];
      // Normalize: accesorios → accesorio
      if (hash === 'accesorios') hash = 'accesorio';
      if (!FILTER_KEYS.includes(hash)) return;

      e.preventDefault();

      // If not on homepage, navigate there with hash
      if (window.location.pathname !== '/') {
        window.location.href = '/#' + hash;
        return;
      }

      // On homepage: scroll to collection section then apply filter
      var collectionSection = document.getElementById('collection');
      if (collectionSection) {
        collectionSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function tryFilter() {
        var filterWrap = document.getElementById('filterWrap');
        if (!filterWrap) return;
        var btn = filterWrap.querySelector('[data-filter="' + hash + '"]');
        if (btn) {
          btn.click();
        } else {
          setTimeout(tryFilter, 300);
        }
      }
      setTimeout(tryFilter, 200);
    });

    // Also handle hashchange (e.g. landing on /?#gmt from another page)
    window.addEventListener('hashchange', function() {
      var hash = window.location.hash.replace('#','');
      if (hash === 'accesorios') hash = 'accesorio';
      if (!FILTER_KEYS.includes(hash)) return;
      var filterWrap = document.getElementById('filterWrap');
      if (!filterWrap) return;
      var btn = filterWrap.querySelector('[data-filter="' + hash + '"]');
      if (btn) btn.click();
    });
  }

  /* ── NAV DROPDOWNS (hover + click/touch) ── */
  function initNavDropdowns() {
    document.querySelectorAll('.has-dropdown').forEach(function(item) {
      var toggle = item.querySelector('.nav-link');
      if (!toggle) return;

      // Desktop hover is handled by CSS.
      // For touch devices, use click to toggle.
      toggle.addEventListener('click', function(e) {
        // Only intercept if hover isn't available (touch device)
        if (!window.matchMedia('(hover: hover)').matches) {
          e.preventDefault();
          var wasOpen = item.classList.contains('dd-open');
          document.querySelectorAll('.has-dropdown.dd-open').forEach(function(el) {
            el.classList.remove('dd-open');
          });
          if (!wasOpen) item.classList.add('dd-open');
        }
      });
    });

    // Close on outside click
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.has-dropdown')) {
        document.querySelectorAll('.has-dropdown.dd-open').forEach(function(el) {
          el.classList.remove('dd-open');
        });
      }
    });
  }

  /* ── BEST SELLERS THUMBNAILS ── */
  function initBSThumbs() {
    document.querySelectorAll('.bs-card').forEach(function(card) {
      var mainImg = card.querySelector('.bs-img-wrap img');
      var thumbs = card.querySelectorAll('.bs-thumb-img');
      if (!mainImg || !thumbs.length) return;
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          thumbs.forEach(function(t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          var src = thumb.src.replace(/width=100/, 'width=1200');
          mainImg.src = src;
        });
      });
    });
  }

  /* ── PRODUCT PAGE: COUNTDOWN + VIEWERS ── */
  function initProductPage() {
    // Countdown: tiempo restante hasta medianoche (urgencia real diaria)
    var countdownEl = document.getElementById('pdCountdown');
    if (countdownEl) {
      function updateCountdown() {
        var now = new Date();
        var midnight = new Date(now);
        midnight.setHours(23, 59, 59, 999);
        var diff = midnight - now;
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var pad = function(n) { return n < 10 ? '0' + n : n; };
        // Show delivery date (today + 3-5 days)
        var delivery = new Date(now);
        delivery.setDate(delivery.getDate() + 4);
        var days   = LANG === 'en' ? ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'] : ['dom','lun','mar','mié','jue','vie','sáb'];
        var months = LANG === 'en' ? ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'] : ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
        var orderTxt = LANG === 'en' ? ' · if you order in ' : ' · si pides en ';
        countdownEl.textContent = days[delivery.getDay()] + ' ' + delivery.getDate() + ' ' + months[delivery.getMonth()] + orderTxt + pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      updateCountdown();
      setInterval(updateCountdown, 1000);
    }

    // Offer countdown banner (resets daily at midnight)
    var offerTimer = document.getElementById('pdOfferTimer');
    if (offerTimer) {
      function updateOfferTimer() {
        var now = new Date();
        var midnight = new Date(now);
        midnight.setHours(23, 59, 59, 999);
        var diff = midnight - now;
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var pad = function(n) { return n < 10 ? '0' + n : n; };
        offerTimer.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      updateOfferTimer();
      setInterval(updateOfferTimer, 1000);
    }

    // Viewers counter: fluctúa de forma realista
    var viewersEl = document.getElementById('pdViewers');
    if (viewersEl) {
      var base = Math.floor(Math.random() * 8) + 9;
      viewersEl.textContent = base;
      setInterval(function() {
        var delta = Math.random() > 0.5 ? 1 : -1;
        base = Math.max(6, Math.min(24, base + delta));
        viewersEl.textContent = base;
      }, 7000);
    }
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initNav();
    initReveal();
    initFAQ();
    initNLForm();
    initNewsletter();
    initCookies();
    initBSThumbs();
    initPolicyTitles();
    initCartDrawer();
    initCollectionNav();
    initNavDropdowns();
    initProductPage();
    initExitIntent();
    initStickyBar();
    // Restore saved language
    if (LANG && LANG !== 'es') {
      window.applyLanguage(LANG);
      if (typeof window.applyPageTranslation === 'function') window.applyPageTranslation(LANG);
    }
  });

  /* ── EXIT INTENT POPUP ── */
  function initExitIntent() {
    var overlay = document.getElementById('exitPopup');
    var closeBtn = document.getElementById('exitPopupClose');
    if (!overlay) return;
    if (sessionStorage.getItem('exitShown')) return;

    var triggered = false;
    document.addEventListener('mouseleave', function(e) {
      if (e.clientY < 5 && !triggered) {
        triggered = true;
        sessionStorage.setItem('exitShown', '1');
        overlay.classList.add('is-visible');
      }
    });

    // Mobile: show after 40s of inactivity
    var mobileTimer = setTimeout(function() {
      if (!triggered && window.innerWidth < 769) {
        triggered = true;
        sessionStorage.setItem('exitShown', '1');
        overlay.classList.add('is-visible');
      }
    }, 40000);

    closeBtn.addEventListener('click', function() {
      overlay.classList.remove('is-visible');
    });
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) overlay.classList.remove('is-visible');
    });
  }

  window.exitCopyCode = function() {
    var el = document.getElementById('exitCode');
    var hint = document.getElementById('exitHint');
    if (!el) return;
    navigator.clipboard ? navigator.clipboard.writeText('AURIS10') : (function(){var t=document.createElement('textarea');t.value='AURIS10';document.body.appendChild(t);t.select();document.execCommand('copy');document.body.removeChild(t);})();
    el.classList.add('copied');
    el.textContent = '✓ AURIS10';
    if (hint) hint.textContent = '¡Código copiado!';
  };

  /* ── STICKY MOBILE BUY BAR ── */
  function initStickyBar() {
    var bar = document.getElementById('pdStickyBar');
    var atcBtn = document.getElementById('pdAtcBtn');
    var stickyBtn = document.getElementById('pdStickyBtn');
    if (!bar || !atcBtn) return;

    window.addEventListener('scroll', function() {
      var rect = atcBtn.getBoundingClientRect();
      if (rect.bottom < 0) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    }, { passive: true });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        var buyNow = document.getElementById('pdBuyNowBtn');
        if (buyNow) buyNow.click();
      });
    }
  }

})();

/* ═══════════════════════════════════════════════════════
   CURRENCY CONVERSION SYSTEM — AURIS
   Client-side · Live rates via frankfurter.app · No API key needed
═══════════════════════════════════════════════════════ */
(function() {
  'use strict';

  var CURRENCIES = {
    EUR: { symbol: '€', label: 'EUR €',  locale: 'es-ES', decimals: 2 },
    MXN: { symbol: 'MX$', label: 'MXN $', locale: 'es-MX', decimals: 0 },
    CLP: { symbol: 'CLP$', label: 'CLP $', locale: 'es-CL', decimals: 0 },
    USD: { symbol: 'US$', label: 'USD $', locale: 'en-US', decimals: 2 }
  };

  // Fallback rates (updated monthly) — replaced by live rates
  var FALLBACK_RATES = { EUR: 1, MXN: 19.2, CLP: 985, USD: 1.09 };
  var rates = Object.assign({}, FALLBACK_RATES);
  var activeCurrency = localStorage.getItem('pd_currency') || 'EUR';
  var ratesLoaded = false;

  // Price selector — all price classes in the theme
  // Cart total excluded: handled exclusively by fmt() via pdFormatPrice
  var PRICE_SELECTORS = [
    '.pd-price-sale', '.pd-price-compare',
    '.pd-card-sale', '.pd-card-orig', '.pd-card-price',
    '.bs-price', '.bs-price-old',
    '[data-money]'
  ].join(',');

  function parseEur(el) {
    // Try data-eur first (already parsed)
    var stored = el.getAttribute('data-eur');
    if (stored) return parseFloat(stored);
    // Parse from text content — supports €148,95 and €148.95
    var text = el.textContent || '';
    var clean = text.replace(/[€$£¥MX|CLP|US]*/g, '').replace(/\s/g, '').replace(',', '.');
    var val = parseFloat(clean.replace(/[^0-9.]/g, ''));
    if (!isNaN(val) && val > 0) {
      el.setAttribute('data-eur', val.toString());
      return val;
    }
    return null;
  }

  function formatPrice(eurVal, currency) {
    var info = CURRENCIES[currency] || CURRENCIES.EUR;
    var converted = eurVal * rates[currency];
    var formatted;
    if (info.decimals === 0) {
      formatted = Math.round(converted).toLocaleString(info.locale);
    } else {
      formatted = converted.toLocaleString(info.locale, {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
    }
    if (currency === 'EUR') return '€' + formatted;
    return info.symbol + formatted;
  }

  window.pdFormatPrice = function(eurCents) {
    return formatPrice(eurCents / 100, activeCurrency);
  };

  function convertAllPrices(currency) {
    document.querySelectorAll(PRICE_SELECTORS).forEach(function(el) {
      // Skip percentage badges and non-price elements
      if (el.textContent.includes('%') || el.classList.contains('pd-discount-badge')) return;
      var eurVal = parseEur(el);
      if (eurVal === null) return;
      el.textContent = formatPrice(eurVal, currency);
    });
  }

  function applyStoredCurrency() { // eslint-disable-line
    if (activeCurrency !== 'EUR') {
      convertAllPrices(activeCurrency);
    }
  }

  // Fetch live rates from jsDelivr CDN (CORS-friendly, no API key needed)
  function fetchRates(callback) {
    var cached = localStorage.getItem('pd_rates_v2');
    var cachedTime = localStorage.getItem('pd_rates_time');
    var oneHour = 3600000;
    if (cached && cachedTime && (Date.now() - parseInt(cachedTime)) < oneHour) {
      try {
        rates = JSON.parse(cached);
        ratesLoaded = true;
        if (callback) callback();
        return;
      } catch(e) {}
    }
    fetch('https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/eur.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data && data.eur) {
          rates = { EUR: 1, MXN: data.eur.mxn || FALLBACK_RATES.MXN, CLP: data.eur.clp || FALLBACK_RATES.CLP, USD: data.eur.usd || FALLBACK_RATES.USD };
          localStorage.setItem('pd_rates_v2', JSON.stringify(rates));
          localStorage.setItem('pd_rates_time', Date.now().toString());
        }
        ratesLoaded = true;
        if (callback) callback();
      })
      .catch(function() {
        ratesLoaded = true;
        if (callback) callback();
      });
  }

  /* ── FULL PAGE TRANSLATION ENGINE ── */
  var PAGE_TRANSLATIONS_EN = [
    ['.pd-hero-cta','SHOP NOW'],
    ['.trust-item-title',['Free shipping to Spain','30-day money-back guarantee','100% secure payment','24/7 customer support']],
    ['.trust-item-desc',[
      'Free delivery in 3–5 business days across Spain.',
      'Not happy? Full refund in 30 days, no questions asked.',
      'Visa, PayPal, Apple Pay. 100% encrypted checkout.',
      'Our team responds in under 2 hours, Monday to Saturday.'
    ]],
    ['.cn-section-title',['Technology that makes a difference','3 steps to stay cool','What our customers say','Frequently asked questions','Ready to stay cool this summer?']],
    ['.cn-feat-title',['360° Cool Airflow','8-Hour Battery','Ultra-Quiet <30dB','Only 170g · Foldable']],
    ['.cn-feat-desc',[
      'Dual side motors create an airflow that surrounds your neck from all angles. You feel cool in seconds.',
      '2000mAh rechargeable battery via USB-C. Full charge in 2 hours. Perfect for all-day use.',
      'Quieter than a whisper. Use it at the office, in class or at the cinema without disturbing anyone.',
      'So light you forget it\'s there. Folds in seconds and fits in any bag. Available in 6 colours.'
    ]],
    ['.footer-tagline','AURIS COLINECK — The wearable neck fan that keeps you cool. 360° airflow, 8h battery, ultra-quiet. Hands-free always.'],
    ['.footer-col-title',['Privacy & Terms','Support','COLINECK']],
    ['.footer-disclaimer','AURIS COLINECK · 12-month warranty · 30-day returns · Free shipping Spain'],
    ['.pd-payment-row span','100% secure & encrypted payment'],
    ['.pdrvs-title','Customer Reviews'],
    ['.pdrvs-card-title',['A game changer for summer','Arrived in 4 days, works great','Perfect for summer commute','I bought it for my whole family','Brilliant for sports','Great product, fast delivery']],
    ['.pdrvs-card-text',[
      "I use it every day at work. The office has barely any AC and this summer has been unbearable. Since I got the COLINECK I arrive fresh and work better.",
      "Arrived super fast, perfectly packaged. The airflow is powerful and it's completely silent. Very recommended.",
      "I use it every day on the subway and walking to work. 30°C outside and I arrive without sweating. Battery lasts the whole day. Best purchase of this summer.",
      "I bought 3. One for me, one for my mum and one for my sister. We're all thrilled. Ultra-light, you don't even notice it.",
      "I use it running and it's amazing. Silent, light, doesn't move. The battery lasts 2–3 training days. I don't take it off at the gym.",
      "Really good product. Arrived in 3 days. Air is genuinely strong for its size. Totally worth the €25."
    ]],
    ['.cookie-reject','Reject'],
    ['.cookie-accept','Accept all'],
    ['.cookie-text','🍪 We use our own and third-party cookies to improve your experience and show you relevant ads. You can accept or reject them. <a href="/pages/politica-privacidad" class="cookie-link">More info</a>'],
    ['.cart-empty-msg','Your cart is empty.'],
    ['.cart-checkout-btn span','SECURE CHECKOUT'],
    ['.pd-breadcrumb a:first-child','Home'],
    ['.pd-stars-meta','4.9 &nbsp;·&nbsp; <a href="#reviews" style="color:var(--primary)">+2,847 verified reviews</a>']
  ];

  function applyPageTranslationES() {
    var ES = [
      ['.pd-hero-applied','Ya incluido · Sin código necesario.'],
      ['.pd-hero-cta','COMPRAR COLINECK'],
      ['.trust-item-title',['Envío gratis a España','Garantía devolución 30 días','Pago 100% seguro','Soporte 24/7']],
      ['.trust-item-desc',[
        'Entrega gratuita en 3–5 días laborables en toda España.',
        '¿No te convence? Devolución completa en 30 días sin preguntas.',
        'Visa, PayPal, Apple Pay. Pago 100% encriptado.',
        'Respondemos en menos de 2 horas, de lunes a sábado.'
      ]],
      ['.cn-feat-title',['360° de Aire Frío','Batería de 8 Horas','Ultrasilencioso <30dB','Solo 170g · Plegable']],
      ['.cn-feat-desc',[
        'Doble motor lateral que rodea tu cuello de aire frío desde todos los ángulos. Lo sientes en segundos.',
        'Batería de 2000mAh recargable vía USB-C. Carga completa en 2 horas. Perfecta para todo el día.',
        'Más silencioso que un susurro. Úsalo en la oficina, en clase o en el cine sin molestar a nadie.',
        'Tan ligero que lo olvidas en el cuello. Se pliega en segundos y cabe en cualquier bolso.'
      ]],
      ['.faq-support-text','Nuestro equipo responde en menos de 2 horas, de lunes a sábado.'],
      ['.faq-contact-btn','Contactar soporte →'],
      ['.ig-title','Síguenos en Instagram'],
      ['.ig-sub','Novedades, ofertas exclusivas y momentos reales de nuestra comunidad usando el COLINECK.'],
      ['.nl-sub','Ofertas exclusivas y consejos para sobrevivir el verano. Sin spam, solo lo bueno.'],
      ['.nl-note','Sin spam. Cancela cuando quieras.'],
      ['.footer-tagline','AURIS COLINECK — El ventilador de cuello wearable que te mantiene fresco. 360° de aire frío, 8h de batería, ultrasilencioso. Manos libres siempre.'],
      ['.footer-col-title',['Privacidad y Condiciones','Asistencia','COLINECK']],
      ['.footer-disclaimer','AURIS COLINECK · Garantía 12 meses · Devolución 30 días · Envío gratis España'],
      ['.pd-payment-row span','Pago 100% seguro y encriptado'],
      ['.pdrvs-title','Opiniones de Clientes'],
      ['.pdrvs-card-title',['Un antes y un después en el verano','Llegó en 4 días y funciona genial','Perfecto para el transporte público','Lo regalo a toda mi familia','Lo uso haciendo deporte y es genial','Buen producto, envío rápido']],
      ['.pdrvs-card-text',[
        'Me sorprendió la calidad del acabado. El cristal de zafiro impresiona y el movimiento es muy suave. Llevo 3 meses llevándolo y está perfecto.',
        'Llegó en 8 días perfectamente embalado. El reloj es idéntico a las fotos, los colores son vivos y la correa muy cómoda. Totalmente recomendado.',
        'Realmente impresionado con la calidad de construcción. El cristal de zafiro es cristalino, el movimiento funciona suave. Parece un reloj que vale 5 veces más. Volvería a pedir.',
        'La primera vez que lo vi en persona me quedé sin palabras. El peso es el justo, el acabado es premium y el cristal de zafiro no tiene ni un rasguño después de meses de uso diario.',
        'Se lo regalé a mi padre por su cumpleaños y quedó encantado. La presentación es muy cuidada, la caja es elegante. Atención al cliente muy rápida.',
        'El reloj supera las expectativas de calidad. Tardó 9 días en llegar. El cierre podría ser más robusto, pero en general muy satisfecho.'
      ]],
      ['.cookie-reject','Rechazar'],
      ['.cookie-accept','Aceptar todas'],
      ['.cookie-text','🍪 Usamos cookies propias y de terceros para mejorar tu experiencia y mostrarte publicidad relevante. Puedes aceptarlas o rechazarlas. <a href="/pages/politica-privacidad" class="cookie-link">Más info</a>'],
      ['.cart-empty-msg','Tu carrito está vacío.'],
      ['.cart-checkout-btn span','PAGAR DE FORMA SEGURA'],
      ['.pd-breadcrumb a:first-child','Inicio'],
      ['.pd-stars-meta','4.8 &nbsp;·&nbsp; <a href="#reviews" style="color:var(--primary)">+1.600 opiniones verificadas</a>']
    ];

    ES.forEach(function(item) {
      var sel = item[0], txt = item[1];
      var els = document.querySelectorAll(sel);
      if (!els.length) return;
      if (Array.isArray(txt)) {
        els.forEach(function(el, i) { if (txt[i] != null) el.innerHTML = txt[i]; });
      } else {
        els.forEach(function(el) { el.innerHTML = txt; });
      }
    });

    var nl = document.querySelector('.nl-title');
    if (nl) nl.innerHTML = 'Suscríbete y obtén un <em style="font-style:italic;color:var(--cn-blue)">10% de descuento</em>';

    var proof = document.querySelector('.pd-social-proof');
    if (proof) {
      var n = document.getElementById('pdViewers');
      var num = n ? n.textContent : '14';
      proof.innerHTML = '<span class="pd-pulse-dot"></span><span id="pdViewers">' + num + '</span> personas están viendo esto ahora';
    }

    document.querySelectorAll('.pd-stock-alert').forEach(function(el) {
      var t = el.innerHTML;
      if (t.includes('Only')) {
        var m = t.match(/\d+/); var qty = m ? m[0] : '';
        el.innerHTML = '🔴 <strong>Solo quedan <span id="pdStock">' + qty + '</span> unidades</strong> al precio actual';
      } else if (t.includes('In stock')) {
        el.innerHTML = '🟢 <strong>En stock</strong> — listo para enviar';
      } else if (t.includes('Available')) {
        el.innerHTML = '🟢 <strong>Disponible</strong> — sale en 24–48h';
      }
    });

    var ship = document.querySelector('.pd-ship-today');
    if (ship) {
      var cd = document.getElementById('pdCountdown');
      var cdTxt = cd ? cd.textContent : '';
      ship.innerHTML = '⚡ Pide hoy — entrega estimada <strong id="pdCountdown">' + cdTxt + '</strong>';
    }

    var tls = document.querySelectorAll('.pd-tl');
    var tlTextsES = [
      '<strong>Set de correa de cuero gratuito</strong> incluido en tu pedido',
      '<strong>Garantía oficial 2 años</strong> contra defectos de fabricación',
      'Entrega estimada en <strong>3–5 días laborables</strong>',
      '<strong>Devoluciones gratuitas</strong> en 30 días sin preguntas'
    ];
    tls.forEach(function(tl, i) {
      var span = tl.querySelector('span:last-child');
      if (span && tlTextsES[i]) span.innerHTML = tlTextsES[i];
    });

    var faqQs = document.querySelectorAll('.faq-q');
    ['¿Por qué comprar en AURIS Watches??','¿Dónde se fabrican los relojes?','¿Qué incluye el pedido?','¿A qué países enviáis? ¿Cuánto tarda?','¿Hay gastos de aduana para México y Chile?'].forEach(function(txt, i) {
      if (!faqQs[i]) return;
      var svg = faqQs[i].querySelector('svg');
      faqQs[i].textContent = txt + ' ';
      if (svg) faqQs[i].appendChild(svg);
    });

    var faqAs = document.querySelectorAll('.faq-a p');
    [
      'Somos una tienda AURIS Luxury Timepieces con miles de clientes satisfechos en todo el mundo. Garantizamos la autenticidad de todos nuestros relojes, respaldados por una garantía de 2 años y soporte personalizado.',
      'Los relojes AURIS se fabrican en China bajo estrictos estándares de calidad. Incorporan movimientos japoneses de precisión (Miyota, NH34, NH35, VK63) y cristal de zafiro con tratamiento antirreflejos multicapa.',
      'Cada pedido incluye: caja oficial AURIS, paño de microfibra, manuales de instrucciones y documentación de garantía. En pedidos superiores a €150, añadimos un set de correa de cuero gratis.',
      'Enviamos a <strong>España, México y Chile</strong>. Tiempos estimados: <strong>España</strong> 3–5 días · <strong>México</strong> 7–12 días · <strong>Chile</strong> 10–15 días. Todos los pedidos incluyen seguimiento en tiempo real. Envío gratis en pedidos superiores a €50.',
      'Para envíos a <strong>España</strong> (dentro de la UE) el precio final incluye todos los impuestos. Para <strong>México y Chile</strong>, los paquetes pueden estar sujetos a inspección aduanera, aunque la mayoría de pedidos de relojes quedan por debajo del umbral de exención.'
    ].forEach(function(t, i) { if (faqAs[i]) faqAs[i].innerHTML = t; });

    var fSets = document.querySelectorAll('.footer-links');
    [
      ['Política de privacidad','Términos del servicio','Política de devoluciones','Política de envío'],
      ['Contacto','Preguntas frecuentes','Garantía & Devoluciones','Información de envío','Seguimiento de pedido'],
      ['Historia y visión','Por qué elegirnos','La diferencia Pagani','Colección completa','Newsletter — 5% dto.']
    ].forEach(function(set, i) {
      if (!fSets[i]) return;
      fSets[i].querySelectorAll('a').forEach(function(a, j) { if (set[j]) a.textContent = set[j]; });
    });

    var bLinks = document.querySelectorAll('.footer-bottom-links a');
    ['Política de privacidad','Política de devoluciones','Términos del servicio'].forEach(function(t, i) { if (bLinks[i]) bLinks[i].textContent = t; });

    var copy = document.querySelector('.footer-bottom > span');
    if (copy) copy.textContent = '© 2026, AURIS Watches. Todos los derechos reservados.';

    var ddTitle = document.querySelector('.nav-locale-dd-title');
    if (ddTitle) ddTitle.textContent = 'Elige tu país e idioma';

    var atc = document.querySelector('.pd-atc-btn');
    if (atc && atc.textContent.includes('Add')) atc.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Añadir al carrito';
    var buy = document.querySelector('.pd-buynow-btn');
    if (buy && buy.textContent.includes('Buy')) buy.textContent = '⚡ Comprar ahora';

    document.querySelectorAll('.pd-img-badge').forEach(function(el) {
      el.innerHTML = el.innerHTML.replace('SALE', 'OFERTA');
    });

    document.querySelectorAll('.pd-offer-banner').forEach(function(el) {
      el.innerHTML = el.innerHTML
        .replace('OFFER EXPIRES IN', 'OFERTA EXPIRA EN')
        .replace(/·\s*-(\d+)%\s*APPLIED/, '· -$1% APLICADO')
        .replace(/LIMITED TIME OFFER\s*—\s*(\d+)% DISCOUNT APPLIED!/i, 'OFERTA POR TIEMPO LIMITADO — ¡$1% DE DESCUENTO aplicado!');
    });
  }

  function applyPageTranslation(lang) {
    /* AQUASOUND: motor de traducción de Colineck/relojes DESACTIVADO —
       el texto AquaSound vive en los .liquid y no debe sobrescribirse. */
    return;
    if (lang !== 'en') { applyPageTranslationES(); return; }

    PAGE_TRANSLATIONS_EN.forEach(function(item) {
      var sel = item[0], txt = item[1];
      var els = document.querySelectorAll(sel);
      if (!els.length) return;
      if (Array.isArray(txt)) {
        els.forEach(function(el, i) { if (txt[i] != null) el.innerHTML = txt[i]; });
      } else {
        els.forEach(function(el) { el.innerHTML = txt; });
      }
    });

    // Elements with <em> or complex HTML
    var h = document.querySelector('.pd-hero-discount');
    if (h) h.innerHTML = 'Free leather strap set <strong>FREE</strong><br>on orders over €150';

    document.querySelectorAll('.section-title').forEach(function(el) {
      var t = el.textContent.trim();
      if (t.includes('Todos los')) el.innerHTML = 'All <em>Watches</em>';
      else if (t.includes('La Diferencia') || t.includes('AURIS')) el.innerHTML = 'The <em>AURIS</em> Difference';
      else if (t.includes('Preguntas')) el.innerHTML = 'Frequently Asked <em>Questions</em>';
      else if (t.includes('Nuestros') || t.includes('Vendidos')) el.innerHTML = 'Our Best Sellers';
    });

    document.querySelectorAll('.section-eyebrow').forEach(function(el) {
      var t = el.textContent.trim();
      if (t.includes('Por qué')) el.textContent = 'Excellence · Why choose us';
      else if (t.includes('Soporte')) el.textContent = 'Support · Premium Service';
    });

    var nl = document.querySelector('.nl-title');
    if (nl) nl.innerHTML = 'Subscribe and get <em style="font-style:italic;color:var(--gold)">5% off</em>';

    var proof = document.querySelector('.pd-social-proof');
    if (proof) {
      var n = document.getElementById('pdViewers');
      var num = n ? n.textContent : '14';
      proof.innerHTML = '<span class="pd-pulse-dot"></span><span id="pdViewers">' + num + '</span> people are viewing this now';
    }

    document.querySelectorAll('.pd-stock-alert').forEach(function(el) {
      var t = el.innerHTML;
      if (t.includes('Solo quedan')) {
        var m = t.match(/\d+/); var qty = m ? m[0] : '';
        el.innerHTML = '🔴 <strong>Only <span id="pdStock">' + qty + '</span> units left!</strong> at current price';
      } else if (t.includes('En stock')) {
        el.innerHTML = '🟢 <strong>In stock</strong> — ready to ship';
      } else if (t.includes('Disponible')) {
        el.innerHTML = '🟢 <strong>Available</strong> — ships in 24–48h';
      }
    });

    var ship = document.querySelector('.pd-ship-today');
    if (ship) {
      var cd = document.getElementById('pdCountdown');
      var cdTxt = cd ? cd.textContent : '';
      ship.innerHTML = '⚡ Order today — estimated delivery <strong id="pdCountdown">' + cdTxt + '</strong>';
    }

    var tls = document.querySelectorAll('.pd-tl');
    var tlTexts = [
      '<strong>Free leather strap set</strong> included in your order',
      '<strong>Official 2-year warranty</strong> against manufacturing defects',
      'Estimated delivery in <strong>3–5 business days</strong>',
      '<strong>Free returns</strong> within 30 days, no questions asked'
    ];
    tls.forEach(function(tl, i) {
      var span = tl.querySelector('span:last-child');
      if (span && tlTexts[i]) span.innerHTML = tlTexts[i];
    });

    var faqQs = document.querySelectorAll('.faq-q');
    ['Why buy from our AURIS Watches?','Where are the watches made?','What is included in the order?','Which countries do you ship to? How long does it take?','Are there customs fees for Mexico and Chile?'].forEach(function(txt, i) {
      if (!faqQs[i]) return;
      var svg = faqQs[i].querySelector('svg');
      faqQs[i].textContent = txt + ' ';
      if (svg) faqQs[i].appendChild(svg);
    });

    var faqAs = document.querySelectorAll('.faq-a p');
    [
      "We are AURIS Luxury Timepieces, with thousands of satisfied customers worldwide. We guarantee the authenticity of all our watches, backed by a 2-year warranty and personalized support.",
      'AURIS watches are manufactured in China under strict quality standards. They incorporate precision Japanese movements (Miyota, NH34, NH35, VK63) and sapphire crystal with multi-layer anti-reflective treatment.',
      'Each order includes: official AURIS box, microfiber cloth, instruction manuals and warranty documentation. On orders over €150, we add a free leather strap set as a gift.',
      'We ship to <strong>Spain, Mexico and Chile</strong>. Estimated times: <strong>Spain</strong> 3–5 days · <strong>Mexico</strong> 7–12 days · <strong>Chile</strong> 10–15 days. All orders include real-time tracking. Free shipping on orders over €50.',
      'For shipments to <strong>Spain</strong> (within the EU) the final price includes all taxes. For <strong>Mexico and Chile</strong>, packages may be subject to customs inspection, though most watch orders fall below the exemption threshold.'
    ].forEach(function(t, i) { if (faqAs[i]) faqAs[i].innerHTML = t; });

    document.querySelectorAll('.pd-img-badge').forEach(function(el) {
      el.innerHTML = el.innerHTML.replace('OFERTA', 'SALE');
    });

    document.querySelectorAll('.pd-offer-banner').forEach(function(el) {
      el.innerHTML = el.innerHTML
        .replace('OFERTA EXPIRA EN', 'OFFER EXPIRES IN')
        .replace(/·\s*-(\d+)%\s*APLICADO/, '· -$1% APPLIED')
        .replace(/OFERTA POR TIEMPO LIMITADO\s*—\s*¡(\d+)% DE DESCUENTO aplicado!/i, 'LIMITED TIME OFFER — $1% DISCOUNT APPLIED!');
    });

    var fSets = document.querySelectorAll('.footer-links');
    [
      ['Privacy Policy','Terms of Service','Refund Policy','Shipping Policy'],
      ['Contact','FAQ','Warranty & Returns','Shipping Info','Track Order'],
      ['Our Story','Why choose us','The AURIS Difference','Full Collection','Newsletter — 5% off']
    ].forEach(function(set, i) {
      if (!fSets[i]) return;
      fSets[i].querySelectorAll('a').forEach(function(a, j) { if (set[j]) a.textContent = set[j]; });
    });

    var bLinks = document.querySelectorAll('.footer-bottom-links a');
    ['Privacy Policy','Refund Policy','Terms of Service'].forEach(function(t, i) { if (bLinks[i]) bLinks[i].textContent = t; });

    var copy = document.querySelector('.footer-bottom > span');
    if (copy) copy.textContent = '© 2026, AURIS Watches. All rights reserved.';

    var ddTitle = document.querySelector('.nav-locale-dd-title');
    if (ddTitle) ddTitle.textContent = 'Choose your country & language';

    // Product page: Add to cart / Buy now buttons
    var atc = document.querySelector('.pd-atc-btn');
    if (atc && atc.textContent.includes('Añadir')) atc.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Add to cart';
    var buy = document.querySelector('.pd-buynow-btn');
    if (buy && buy.textContent.includes('Comprar')) buy.textContent = '⚡ Buy now';
  }

  window.applyPageTranslation = applyPageTranslation;

  // Public: set currency and convert prices
  window.pdSetCurrency = function(currency, lang) {
    if (!CURRENCIES[currency]) return;
    activeCurrency = currency;
    localStorage.setItem('pd_currency', currency);

    // Update nav button label
    var cs = document.getElementById('navLocaleCurrency');
    if (cs) cs.textContent = CURRENCIES[currency].label;

    function doConvert() {
      convertAllPrices(currency);
      // Update cart prices if cart drawer is visible
      if (typeof window.pdRefreshCart === 'function') window.pdRefreshCart();
    }

    if (ratesLoaded) {
      doConvert();
    } else {
      fetchRates(doConvert);
    }

    // Language switch — client-side instantáneo
    if (typeof window.applyLanguage === 'function') {
      window.applyLanguage(lang || 'es');
    }
    if (typeof window.applyPageTranslation === 'function') {
      window.applyPageTranslation(lang || 'es');
    }
  };

  // Init on page load
  document.addEventListener('DOMContentLoaded', function() {
    fetchRates(function() {
      if (activeCurrency !== 'EUR') {
        convertAllPrices(activeCurrency);
        // Update nav button
        var cs = document.getElementById('navLocaleCurrency');
        var fi = document.getElementById('navFlagImg');
        var flagMap = { MXN: ['https://flagcdn.com/20x15/mx.png','México'], CLP: ['https://flagcdn.com/20x15/cl.png','Chile'], USD: ['https://flagcdn.com/20x15/us.png','United States'] };
        if (cs && CURRENCIES[activeCurrency]) cs.textContent = CURRENCIES[activeCurrency].label;
        if (fi && flagMap[activeCurrency]) { fi.src = flagMap[activeCurrency][0]; fi.alt = flagMap[activeCurrency][1]; }
      }
    });

    // Re-apply after dynamic content loads (catalog, cart)
    var observer = new MutationObserver(function() {
      if (activeCurrency !== 'EUR' && ratesLoaded) {
        convertAllPrices(activeCurrency);
      }
    });
    var grid = document.getElementById('productsGrid');
    if (grid) observer.observe(grid, { childList: true, subtree: false });
  });

})();

/* ── Brand name correction: Pagani Design → AURIS on about page ── */
(function () {
  if (!window.location.pathname.includes('sobre-nosotros')) return;
  function fixBrand() {
    document.querySelectorAll('.about-eyebrow, .about-lead').forEach(function (el) {
      el.innerHTML = el.innerHTML.replace(/Pagani Design/g, 'AURIS');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixBrand);
  } else {
    fixBrand();
  }
})();
